import { useQuery } from "@tanstack/react-query";
import { RestEndpoints } from "../../../api/endpoints";
import { ReactQueryConfig } from "../../../config/react-query-config";
import { IPomReportingPosition } from "../../../domain/reporting/pom-reporting";
import { PomReportingConverter } from "../../models/converter/pom-reporting.converter";
import { IPomReportingModel } from "../../models/reportings/pom-reporting.model";
import { PomQueryKeys } from "../../pom-query-keys";
import getInstance from "../../../utils/rest";

const getReporting = async (contractNo: string, reportingNo: number): Promise<IPomReportingPosition[]> => {
  const result = await getInstance().get<IPomReportingModel>(
    `${RestEndpoints.PomReportings}/${contractNo}/${reportingNo}`,
  );
  return PomReportingConverter.toPositions(result.data);
};

export const useGetReportingQuery = (contractNo: string | undefined, reportingNo: number | undefined) => {
  return useQuery({
    queryKey: [PomQueryKeys.GetReporting, contractNo, reportingNo],
    queryFn: () => getReporting(contractNo as string, reportingNo as number),
    staleTime: ReactQueryConfig.staleTime,
    enabled: !!contractNo && reportingNo !== undefined,
  });
};
